// extracted by mini-css-extract-plugin
export default {"header":"MetropoleMuseeFabreHeader_header__7e6gI","logo":"MetropoleMuseeFabreHeader_logo__EO26m"};